import React, {Fragment, useRef, useState} from "react";
import SupporterApi from "../../../apis/SupporterApi";

const SwapTicketToasterIdentifier = ({supporterId}) => {

  const modalRef = useRef(null);

  const [newTicketToasterIdentifier, setNewTicketToasterIdentifier] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);

  const handleClick = (e) => {
    const modalElement = modalRef.current;

    // If ref isn't set or click is outside the modal-content, close the modal
    if (
        modalElement &&
        !e.target.closest(".modal-content")
    ) {
      handleClose();
    }
  };

  const handleOpen = () => {
    setNewTicketToasterIdentifier('');
    setIsOpen(true);
  }

  const handleClose = () => {
    setIsOpen(false);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    SupporterApi.swapTicketToasterIdentifierForSupporterProject(supporterId, newTicketToasterIdentifier)
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
         handleClose();
         window.location.reload();
        } else {
          setErrors(response.data.errors);
        }
      });
  }

  return (
    <Fragment>
      <button className="btn btn-warning" onClick={handleOpen}>
        Bändsel tauschen
      </button>
      {isOpen && (
        <div className="modal inmodal in" tabIndex="-1" role="dialog" style={{display: 'block'}} ref={modalRef} onClick={handleClick}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button className="close" onClick={handleClose}>
                  <span>x</span>
                </button>
                <h4 className="modal-title">
                  Bändsel tauschen
                </h4>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="alert alert-warning">
                    Achtung! Das Tauschen des Bändsels solle nur in Spezialfällen durchgeführt werden.<br/>
                    Bitte prüfe vorher mit einem Ticket-Toaster-Gerät, ob das Bändchen wirklich nicht auslesbar ist. Nur
                    dann ist ein Tausch sinnvoll.
                  </div>
                  Bitte lege jetzt das neue Bändsel auf den NFC-Reader und schaue, dass die Nummer im folgenden Feld
                  auftaucht.<br/>
                  <input className="form-control" autoFocus={true} type="text" value={newTicketToasterIdentifier}
                         onChange={(e) => setNewTicketToasterIdentifier(e.target.value)}/>
                  <button type="submit" disabled={loading} className="btn btn-warning m-t-lg">
                    Neues Bändsel speichern
                  </button>
                  {errors && errors.newTicketToasterIdentifier ? (
                    <div className="alert alert-danger m-t-lg">
                      {errors.newTicketToasterIdentifier}
                    </div>
                  ) : null}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  )
}

export default SwapTicketToasterIdentifier;